var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/SeatRequestModal/RequestModalContent.js",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { T, t } from '@sm/intl';
import { Modal } from '@wds/modal';
import { Button } from '@wds/button';
import { Link } from '@wds/link';
import { Textarea } from '@wds/textarea';
import CreateSeatRequestMutation from './graphql/CreateSeatRequest.graphql';
import COPY from './SeatRequestCopy';
import { STATUS } from './constants';
import { StaticContext } from '../StaticContext';
import { getHelpCenterLink } from '../../helpers/getHelpLink';
var MAX_MESSAGE_LENGTH = 400;
var useArticleHelpLink = function useArticleHelpLink(path) {
  var staticContext = useContext(StaticContext);
  return getHelpCenterLink(staticContext === null || staticContext === void 0 ? void 0 : staticContext.user.language, {
    path: path
  });
};
var LinkRenderer = function LinkRenderer(link) {
  var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (_ref) {
    var children = _ref.children;
    return /*#__PURE__*/React.createElement(Link, {
      target: newTab ? '_blank' : undefined,
      rel: newTab ? 'noreferrer noopener' : undefined,
      href: link,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 7
      }
    }, children);
  };
};
LinkRenderer.propTypes = {
  newTab: PropTypes.bool.isRequired,
  helpLink: PropTypes.string.isRequired
};
var RequestModalContent = function RequestModalContent(_ref2) {
  var onModalFinished = _ref2.onModalFinished,
    sourceCategoryKey = _ref2.sourceCategoryKey,
    sourceFeatureKey = _ref2.sourceFeatureKey,
    isCasualUserAllowExport = _ref2.isCasualUserAllowExport;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    reason = _useState2[0],
    setReason = _useState2[1];
  var _useMutation = useMutation(CreateSeatRequestMutation, {
      onError: function onError() {
        onModalFinished({
          status: STATUS.FAILURE,
          message: t(COPY.TOAST_ERROR)
        });
      },
      onCompleted: function onCompleted() {
        setReason('');
        onModalFinished({
          status: STATUS.SUCCESS,
          message: t(COPY.TOAST_REQUEST_SENT)
        });
      }
    }),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    createSeatRequest = _useMutation2[0],
    loading = _useMutation2[1].loading;
  var onSubmit = function onSubmit() {
    createSeatRequest({
      variables: {
        input: {
          seatType: 'POWER_USER',
          reason: reason.length > 0 ? reason : null,
          sourceCategoryKey: sourceCategoryKey,
          sourceFeatureKey: sourceFeatureKey
        }
      }
    });
  };
  var helpLink = useArticleHelpLink('teams/enterprise-seats');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, {
    header: /*#__PURE__*/React.createElement(T, {
      desc: COPY.MODAL_TITLE_AVAILABLE,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 29
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("b", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.REQUEST_DESC_1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: isCasualUserAllowExport ? COPY.REQUEST_DESC_2_ALLOW_EXPORT : COPY.REQUEST_DESC_2,
    values: {
      'help-link': LinkRenderer(helpLink, true)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Textarea, {
    label: t(COPY.REASON_LABEL),
    value: reason,
    maxLength: MAX_MESSAGE_LENGTH,
    onChange: function onChange(e) {
      return setReason(e.target.value);
    },
    stretched: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Modal.Footer, {
    align: "right",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    color: "secondary",
    disabled: loading,
    onClick: onModalFinished,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CANCEL_BUTTON,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    disabled: loading,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.SEND_BUTTON,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 11
    }
  }))));
};
RequestModalContent.propTypes = {
  onModalFinished: PropTypes.func.isRequired,
  sourceCategoryKey: PropTypes.string.isRequired,
  sourceFeatureKey: PropTypes.string,
  isCasualUserAllowExport: PropTypes.bool
};
RequestModalContent.defaultProps = {
  sourceFeatureKey: null,
  isCasualUserAllowExport: false
};
export default RequestModalContent;
//# sourceMappingURL=RequestModalContent.js.map